module.exports = __webpack_public_path__ + "img/sound-on-icon.dd7dd7bb.svg";